export enum SetReadReceiptsTypes {
  onChatOpen = 'onChatOpen',
  always = 'always',
  never = 'never',
}

export enum HandleEvent {
  HandleAck = 'HANDLE_ACK',
  HandleStateChange = 'HANDLE_STATECHANGE',
  HandleMessage = 'HANDLE_MESSAGE',
}
